/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import UserMenu from '../../Components/UserMenu/UserMenu.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import AccountPageSidebarPropTypes from './Account.page.sidebar.props';
import accountPageStyles from './Account.page.styles';

/**
 * AccountPageSidebarComponent
 * @export
 * @class AccountPageSidebarComponent
 * @extends {React.Component<AccountPageSidebarComponentComposedProps, AccountPageSidebarComponentState>}
 */
export class AccountPageSidebarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<AccountPageSidebarComponentProps>}
   * @memberof AccountPageSidebarComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`AccountPageSidebar`}
   * @memberof AccountPageSidebarComponent
   */
  static displayName = `AccountPageSidebar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof AccountPageSidebarComponent
   */
  static propTypes = AccountPageSidebarPropTypes;

  /**
   * Data specific to the `<AccountPageSidebar />` instance
   * @type {AccountPageSidebarComponentState}
   * @memberof AccountPageSidebarComponent
   */
  state = {};

  /**
   * Render the sidebar
   * @returns {React.Component} The rendered `<OrderPageSidebar />`
   * @memberof AccountPageSidebarComponent
   */
  render() {
    return <UserMenu showAvatar={false} />;
  }
}

/** @type {React.ComponentClass<AccountPageSidebarComponentProps>} */
const AccountPageSidebar = compose(withStyles(themeCreateInjectableStyles(accountPageStyles), { withTheme: true }))(AccountPageSidebarComponent);

export default AccountPageSidebar;
